import { getListData } from './getListData';

export const getInitialData = (data: string[]) => {
  const listData = getListData(data);

  return {
    bulkInput: '',
    textareaDisabled: false,
    listData,
    validItems: [],
    bulkErrors: [],
  };
};
